import { Pipe, PipeTransform } from '@angular/core';

const units: string[] = ['Bytes', 'kB', 'MB', 'GB', 'TB'];

@Pipe({
  name: 'bytesHumanReadable'
})
export class BytesHumanReadablePipe implements PipeTransform {

  /**
   * Convert bytes to a human readable text
   *
   * @param value bytes number
   * @param unit SI unit of the given value: 'kB', 'MB', 'GB', 'TB'
   * @returns The number and the unit as text
   */
  transform(value: number, unit?: string): string {
    let unitIndex = 0;
    if (isNaN(value)) return 'unknownValue';
    if (unit) {
      if (!units.includes(unit))
        throw new Error('Unsupported unit');
      else
        unitIndex = units.indexOf(unit);
    }

    if (value > 0) {
      const x = Math.pow(1000, unitIndex);
      const toReturn = value / x;
      return `${toReturn.toFixed(2)} [${units[unitIndex]}]`;
    }
    else
      return `0 [${units[unitIndex]}]`;
  }
}
